import { defineComponent, computed } from 'vue';
import { isNumber } from '../../../utils/util.mjs';
import { iconProps } from './icon.mjs';
import { isString } from '@vue/shared';

var script = defineComponent({
  name: "ElIcon",
  inheritAttrs: false,
  props: iconProps,
  setup(props) {
    return {
      style: computed(() => {
        if (!props.size && !props.color) {
          return {};
        }
        let size = props.size;
        if (isNumber(size) || isString(size) && !size.endsWith("px")) {
          size = `${size}px`;
        }
        return {
          ...props.size ? { "--font-size": size } : {},
          ...props.color ? { "--color": props.color } : {}
        };
      })
    };
  }
});

export { script as default };
//# sourceMappingURL=icon.vue_vue_type_script_lang.mjs.map
